<div class="page-title-area">
  <div class="d-table">
      <div class="d-table-cell">
          <div class="container">
              <div class="page-title-text">
                  <h2>About Us</h2>
                  <ul>
                      <li><a routerLink="/">Home</a></li>
                      <li><i class="icofont-simple-right"></i></li>
                      <li>About Us</li>
                  </ul>
              </div>
          </div>
      </div>
  </div>
</div>

<div class="portal-area pt-100 pb-70">
  <div class="container">
      <div class="row align-items-center">
          <div class="col-lg-6">
              <div class="portal-item">
                  <div class="row">
                      <div class="col-lg-7">
                          <img src="../../../assets/img/home/trusted_2c.jpg" alt="Portal">
                      </div>

                      <!-- <div class="col-lg-5">
                          <img src="../../../assets/img/home/trusted_2.jpg" alt="Portal">
                      </div> -->
                  </div>

                  <div class="portal-trusted">
                      <span>100% Trusted</span>
                  </div>
              </div>
          </div>

          <div class="col-lg-6">
              <div class="portal-item portal-right portal-right-two">
                  <h2>A Service Portal You Can Trust</h2>
                  <p>Our pride has and will always be <b>connecting</b> clients to services.Therefore, our improved <b>Aritificial
                    Intelligent (A.I)</b> algorithm simplifies and streamline search criteria giving the best match to desired service needs.
                  </p>

                  <div class="portal-counter-area">
                      <div class="row">
                          <div class="col-6 col-sm-4 col-lg-4">
                              <div class="counter-item">
                                  <h3><span class="counter">{{serviceTotal}}</span>+</h3>
                                  <p>Registered Services</p>
                              </div>
                          </div>

                          <div class="col-6 col-sm-4 col-lg-4">
                              <div class="counter-item">
                                  <h3><span class="counter">0</span>+</h3>
                                  <p>Registered Client</p>
                              </div>
                          </div>

                          <div class="col-6 col-sm-4 col-lg-4">
                              <div class="counter-item">
                                  <h3><span class="counter">0</span>+</h3>
                                  <p>Reliable Companies</p>
                              </div>
                          </div>

                          <div class="col-6 col-sm-6 col-lg-4 offset-lg-2">
                              <div class="counter-item">
                                  <h3><span class="counter">0</span>+</h3>
                                  <p>Registered Members</p>
                              </div>
                          </div>

                          <div class="col-6 col-sm-6 col-lg-4">
                              <div class="counter-item">
                                  <h3><span class="counter">0</span>+</h3>
                                  <p>Service Requests</p>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>

<!-- <div class="counter-area pt-100 pb-70">
  <div class="container">
      <div class="row">
          <div class="col-6 col-sm-3 col-lg-3">
              <div class="counter-item">
                  <i class="flaticon-employee"></i>
                  <h3><span class="counter">14</span>k+</h3>
                  <p>Job Available</p>
              </div>
          </div>

          <div class="col-6 col-sm-3 col-lg-3">
              <div class="counter-item">
                  <i class="flaticon-curriculum"></i>
                  <h3><span class="counter">18</span>k+</h3>
                  <p>CV Submitted</p>
              </div>
          </div>

          <div class="col-6 col-sm-3 col-lg-3">
              <div class="counter-item">
                  <i class="flaticon-enterprise"></i>
                  <h3><span class="counter">9</span>k+</h3>
                  <p>Companies</p>
              </div>
          </div>

          <div class="col-6 col-sm-3 col-lg-3">
              <div class="counter-item">
                  <i class="flaticon-businessman-paper-of-the-application-for-a-job"></i>
                  <h3><span class="counter">35</span>+</h3>
                  <p>Appointed to Job</p>
              </div>
          </div>
      </div>
  </div>
</div> -->

<div class="popular-area pt-100 pb-170">
  <div class="container">
      <div class="row align-items-center">
          <div class="col-lg-6">
              <div class="popular-item">
                  <div class="row align-items-center">

                    <div class="col-lg-2"></div>
                      <div class="col-lg-8">
                          <img src="../../../assets/img/home/popular_1b.jpg" alt="Popular">
                      </div>
                      <div class="col-lg-2"></div>
                      <!-- <div class="col-lg-5">
                          <div class="practice-inner">
                              <img src="../../../assets/img/home/popular_2.jpg" alt="Popular">
                              <img src="../../../assets/img/home/popular_3.jpg" alt="Popular">
                          </div>
                      </div> -->
                  </div>
              </div>
          </div>

          <div class="col-lg-6">
              <div class="popular-item popular-right">
                  <div class="section-title text-start">
                      <h2>Why We are Most Popular</h2>
                  </div>
                  <p><b class="mycolor">trepez</b>' service portal is <b>simplicity</b>, <b>accuracy</b> and <b>reliabilty</b>. Irrespective of industry or location,
                    we can connect your service needs in just 3 clicks...
                  </p>

                  <div class="row popular-wrap">
                      <div class="col-sm-6 col-lg-6">
                          <ul>
                              <li><i class="flaticon-approved"></i> Quality Service</li>
                              <li><i class="flaticon-employee"></i> Global Awareness</li>
                          </ul>
                      </div>

                      <div class="col-sm-6 col-lg-6">
                          <ul>
                              <li><i class="flaticon-enterprise"></i> Top Companies</li>
                              <li><i class="flaticon-no-money"></i> Completely Free</li>
                          </ul>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>
